import {ChatMessage, ChatMessageAuthor, UserMessageResponse} from '../copilot.model';
import {graphSpec} from '../types';
import {PolarisGraphVm, PolarisMessageVm} from '../../../services/polaris/model';

export const mapPolarisMessagesToChatMessages = (messages: PolarisMessageVm[]): ChatMessage[] => {
  return messages.map((message) => mapPolarisMessageToChatMessage(message));
};

export const mapPolarisMessageToChatMessage = (message: PolarisMessageVm): ChatMessage => {
  return {
    id: message.id,
    author: message.author === 'user' ? ChatMessageAuthor.USER : ChatMessageAuthor.ASSISTANT,
    content: message.content,
    timestamp: message.timestamp,
    followUpQuestions: message.followUpQuestions,
    error: message.error,
    insights: message.insights,
    citations: message.citations,
    webInsights: message.webInsights,
    creativesURLs: message.creativesURLs,
    interactionId: message.interactionId,
    userResponse: mapUserResponse(message.userResponse),
    graphs: message.graphs?.map((graph) => mapGraph(graph)),
    origin: message.origin,
    widgetName: message.widgetName
  };
};

const mapUserResponse = (userResponse: PolarisMessageVm['userResponse']): UserMessageResponse | undefined => {
  if (userResponse === 'positive') {
    return UserMessageResponse.POSITIVE;
  }
  if (userResponse === 'negative') {
    return UserMessageResponse.NEGATIVE;
  }
  return undefined;
};

const mapGraph = (graph: PolarisGraphVm): graphSpec => {
  return {
    ...graph,
    type: mapGraphType(graph.type),
    url: graph.url ?? undefined
  };
};

const mapGraphType = (type: PolarisGraphVm['type']): graphSpec['type'] => {
  if (type === 'doughnut' || type === 'pie_chart') {
    return 'doughnut';
  }
  if (type === 'line' || type === 'line_chart') {
    return 'line';
  }
  return 'bar';
};
